// extracted by mini-css-extract-plugin
module.exports = {"formMessage":"styles__formMessage___3p246","formTitle":"styles__formTitle___2OV7N","formSubTitle":"styles__formSubTitle___2-rVc"};